import u from 'underscore.string/underscored';

const underscored = (string: string) => {
  return u(string);
};

export default underscored;
